<script>
import {defineComponent} from 'vue'
import Breadcrumbs from '@js/components/Breadcrumbs/Breadcrumbs.vue'
import MobileTopBar from '@js/components/TopBar/MobileTopBar.vue'
import {contacts, requisites} from '@js/company_details.ts'
import {formatPhone} from "@js/helpers.ts";
import {Link} from '@inertiajs/vue3'

export default defineComponent({
    name: 'ReturnGuaranteePage',
    components: {Link, MobileTopBar, Breadcrumbs},
    setup() {
        return {contacts, requisites, formatPhone}
    }
})
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs class="mb-2"/>
        <h1 class="text-2xl md:text-3xl">Условия приема, взвешивания и урегулирования спорных ситуаций</h1>
        <hr class="mt-5 mb-5"/>

        <div class="mb-8 prose">
            <p class="text-sm">
                На этой странице размещены общие правила, по которым Вторчермет-1 принимает металлолом,
                определяет итоговый вес, категорию материала, засоренность, а также рассматривает возможные
                претензии и спорные ситуации. Для отдельных сделок, выездов, демонтажа и B2B-клиентов
                приоритет могут иметь условия договора, акта, заявки, счета или иного согласованного документа.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">1. Общие положения</h2>

            <p class="text-sm mb-2">
                1.1. Итоговые условия приема металлолома определяются по фактическому осмотру, взвешиванию,
                сортировке, определению категории материала, степени засоренности, необходимости демонтажа,
                резки, погрузки, транспортировки и иных сопутствующих факторов.
            </p>

            <p class="text-sm mb-2">
                1.2. Информация на сайте о ценах, условиях и порядке расчета носит ознакомительный характер,
                если иное прямо не согласовано сторонами.
            </p>

            <p class="text-sm mb-2">
                1.3. Передавая металлолом, Сдатчик подтверждает, что вправе распоряжаться им на законных основаниях,
                а сам лом не относится к запрещенным или ограниченным в обороте предметам.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">2. Предварительная оценка</h2>

            <p class="text-sm mb-2">
                2.1. Предварительная оценка по телефону, в мессенджере, по фото, видео или описанию является
                ориентировочной и не считается окончательным коммерческим предложением.
            </p>

            <p class="text-sm mb-2">
                2.2. Итоговая цена может отличаться от предварительной оценки после фактического осмотра металлолома,
                сортировки по видам, определения засоренности, наличия неметаллических включений, загрязнений,
                изоляции, примесей, остаточных материалов и иных факторов.
            </p>

            <p class="text-sm mb-2">
                2.3. Если пользователь заказывает выезд на объект, он обязан заранее сообщить достоверные сведения
                о характере металлолома, объеме, месте нахождения, условиях доступа и возможных рисках.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">3. Порядок приема и взвешивания</h2>

            <p class="text-sm mb-2">
                3.1. Прием металлолома осуществляется по фактическому весу и характеристикам материала.
            </p>

            <p class="text-sm mb-2">
                3.2. При необходимости лом сортируется по видам и категориям. Смешанный лом, кабель, металл с
                загрязнениями, примесями, навесным оборудованием, остатками пластика, резины, дерева, бетона,
                грунта или иных включений может оцениваться отдельно либо с учетом засоренности.
            </p>

            <p class="text-sm mb-2">
                3.3. При вывозе лом может приниматься с учетом массы нетто после исключения массы транспорта,
                тары, упаковки, навесных элементов и засоренности, если это применимо к характеру сделки.
            </p>

            <p class="text-sm mb-2">
                3.4. Приемка, осмотр, взвешивание и расчет могут сопровождаться фото- и видеофиксацией для
                подтверждения характеристик партии и урегулирования спорных ситуаций.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">4. Засоренность и примеси</h2>

            <p class="text-sm mb-2">
                4.1. При наличии загрязнений, неметаллических включений, изоляции, масла, горюче-смазочных материалов,
                строительных остатков, земли, воды, стекла, пластика, резины, бетона, дерева и иных примесей компания
                вправе учитывать засоренность при определении расчетного веса и стоимости.
            </p>

            <p class="text-sm mb-2">
                4.2. Если металл требует дополнительной резки, разделки, сортировки, демонтажа, вскрытия, очистки,
                погрузки или специальных условий вывоза, соответствующие расходы могут учитываться отдельно либо
                влиять на итоговую цену.
            </p>

            <p class="text-sm mb-2">
                4.3. При обнаружении опасных вложений, закрытых емкостей, подозрительных предметов, следов топлива,
                химических веществ, элементов под давлением или иных опасных факторов компания вправе отказаться
                от приема до полного устранения риска.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">5. Демонтаж, вывоз и дополнительные расходы</h2>

            <p class="text-sm mb-2">
                5.1. Если металлолом находится на объекте и требует демонтажа, резки, привлечения спецтехники,
                грузчиков, манипулятора, газорезки, контейнеров или иных ресурсов, условия и стоимость таких работ
                согласуются отдельно.
            </p>

            <p class="text-sm mb-2">
                5.2. Пользователь обязан обеспечить законный и безопасный доступ на территорию, подъезд транспорта,
                возможность проведения работ, а также заранее сообщить обо всех ограничениях и рисках.
            </p>

            <p class="text-sm mb-2">
                5.3. Если фактические условия на объекте существенно отличаются от согласованных ранее, компания вправе
                пересмотреть стоимость работ, сроки выезда либо отказаться от исполнения заявки.
            </p>

            <p class="text-sm mb-2">
                5.4. Подробнее об условиях вывоза смотрите на странице
                <Link :href="route('deliveryAndShipping')" class="underline hover:text-navHoverColor font-semibold">
                    «Доставка и вывоз»
                </Link>.
            </p>

            <p class="text-sm mb-2">
                5.5. Порядок сдачи металлолома также описан на странице
                <Link :href="route('howToHandOver')" class="underline hover:text-navHoverColor font-semibold">
                    «Как сдать металлолом»
                </Link>.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">6. Основания для отказа в приеме</h2>

            <p class="text-sm mb-2">
                Компания вправе отказать в приеме металлолома полностью или частично в том числе в следующих случаях:
            </p>

            <ul class="text-sm list-disc pl-5 mb-3 space-y-2">
                <li>отсутствуют необходимые документы или данные о Сдатчике;</li>
                <li>есть сомнения в законности происхождения металлолома;</li>
                <li>лом представляет опасность для сотрудников, оборудования, транспорта или окружающей среды;</li>
                <li>обнаружены признаки радиоактивного загрязнения, взрывоопасности или иных опасных факторов;</li>
                <li>фактический объем, состав или состояние металлолома существенно отличаются от заявленных ранее;</li>
                <li>отсутствует безопасный доступ к объекту или нарушены условия проведения работ.</li>
            </ul>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">7. Порядок расчета</h2>

            <p class="text-sm mb-2">
                7.1. Расчет производится по фактическим данным после определения веса, категории, засоренности и,
                при необходимости, вычета согласованных расходов на выезд, демонтаж, погрузку, резку, транспортировку
                и иные дополнительные работы.
            </p>

            <p class="text-sm mb-2">
                7.2. Форма и срок расчета зависят от характера сделки, статуса Сдатчика, состава партии, наличия
                документов и требований действующего законодательства РФ.
            </p>

            <p class="text-sm mb-2">
                7.3. Для юридических лиц и ИП условия расчетов, документооборот и сроки могут дополнительно
                регулироваться договором, счетом, актом, УПД или иными согласованными документами.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">8. Претензии и спорные ситуации</h2>

            <p class="text-sm mb-2">
                8.1. Если у Сдатчика возникли вопросы по весу, категории материала, засоренности, расчету либо
                дополнительным удержаниям, он вправе направить претензию с описанием ситуации и, по возможности,
                приложением фото, видео, документов и иных подтверждающих материалов.
            </p>

            <p class="text-sm mb-2">
                8.2. Претензия подается в разумный срок после проведения приемки и расчета. Чем раньше направлено
                обращение, тем выше возможность оперативно восстановить фактические обстоятельства.
            </p>

            <p class="text-sm mb-2">
                8.3. Компания рассматривает обращения в рабочее время и старается урегулировать спор в досудебном
                порядке путем переговоров, сверки данных, изучения фото- и видеофиксации, документов и иных сведений.
            </p>

            <p class="text-sm mb-2">
                8.4. Направить обращение можно по телефону {{ formatPhone(contacts.sales_department_phone) }}
                или по e-mail {{ contacts.info_mail }}.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">9. Ограничение гарантий</h2>

            <p class="text-sm mb-2">
                9.1. Компания не гарантирует сохранение предварительной цены до момента фактической приемки, так как
                стоимость лома зависит от рыночной конъюнктуры, состава партии, загрязненности, объема и иных факторов.
            </p>

            <p class="text-sm mb-2">
                9.2. Компания не несет ответственности за расхождения, возникшие вследствие недостоверных сведений,
                предоставленных пользователем, сокрытия состава партии, опасных свойств металлолома либо особенностей
                объекта.
            </p>

            <p class="text-sm mb-2">
                9.3. Компания не отвечает за задержки и невозможность исполнения обязательств, вызванные действиями
                третьих лиц, ограничением доступа на объект, погодными условиями, поломкой техники, требованиями
                безопасности, форс-мажором и иными обстоятельствами вне разумного контроля компании.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">10. Контакты</h2>

            <p class="text-sm mb-2">
                Телефон: {{ formatPhone(contacts.sales_department_phone) }}
            </p>

            <p class="text-sm mb-2">
                E-mail: {{ contacts.info_mail }}
            </p>

            <p class="text-sm mb-2">
                ООО «Вторчермет-1», ИНН {{ requisites.inn }}, КПП {{ requisites.kpp }}, ОГРН {{ requisites.ogrn }}
            </p>

            <p class="text-sm mb-2">
                Юридический адрес: {{ requisites.ur_address }}
            </p>

            <p class="text-sm mb-2">
                Также рекомендуем ознакомиться с
                <Link :href="route('publicOffer')" class="underline hover:text-navHoverColor font-semibold">
                    публичной офертой
                </Link>
                и
                <Link :href="route('privacyPolicy')" class="underline hover:text-navHoverColor font-semibold">
                    политикой конфиденциальности
                </Link>.
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">
.prose a {
    @apply text-yellow-600 hover:text-yellow-800 underline;
}
</style>
